class CollectionsMenu extends HTMLElement {
  constructor() {
    super();

    this.closeElements = this.querySelectorAll('[data-toggle="collapse"]');
    this.details = this.querySelector(".collection_menu__details");
    this.submenuToggles = this.querySelectorAll(["[data-toggle-id]"]);

    this.closeElements.forEach((item) =>
      item.addEventListener("click", this.close.bind(this))
    );

    this.submenuToggles.forEach((item) =>
      item.addEventListener("click", this.openSubmenu.bind(this))
    );
  }

  close(e) {
    this.details.removeAttribute("open");
  }

  openSubmenu(e) {
    e.currentTarget.classList.toggle("open_arrow");

    e.currentTarget.parentElement.classList.toggle("open");

    document
      .getElementById(e.currentTarget.dataset.toggleId)
      .classList.toggle("open");
  }
}

customElements.define("collections-menu", CollectionsMenu);
